import { type SxProps, type Theme } from "@mui/material";
import { useIsHomeHealthEnabled } from "@src/appV2/ExperimentalHomeHealth/lib/useIsHomeHealthEnabled";

import { MESSAGE_CUSTOM_TYPES } from "../constants";
import type { AdminChatMessage } from "../types";
import { parseVisitInviteMessageData } from "../utils/parseVisitInviteMessage";
import { VisitInviteRequestMessage } from "./VisitInviteRequestMessage";

interface VisitInviteMessageRouterProps {
  message: AdminChatMessage;
  sx?: SxProps<Theme>;
}

/**
 * Routes visit invite admin messages to the appropriate component.
 * Only renders when Home Health feature is enabled.
 * Returns null if the feature is disabled or message type doesn't match.
 */
export function VisitInviteMessageRouter(
  props: VisitInviteMessageRouterProps
): React.ReactElement | null {
  const { message, sx } = props;
  const isHomeHealthEnabled = useIsHomeHealthEnabled();

  // Only render for Home Health enabled workplaces
  if (!isHomeHealthEnabled) {
    return null;
  }

  if (message.customType !== MESSAGE_CUSTOM_TYPES.VISIT_INVITE_REQUEST) {
    return null;
  }

  const { visitId } = parseVisitInviteMessageData(message.data);

  return <VisitInviteRequestMessage sx={sx} visitId={visitId} />;
}
